// CourtTypeView.jsimport React from "react";
import DynamicCard from "./MainCardComponent";
import AccountCategoriesTable from "../AccountsAndFinanceManagement/Tables/AccountCategories";
import AccountSubcategoriesTable from "../AccountsAndFinanceManagement/Tables/AcocuntSubcategories";
import SuspendedTransactionsTable from "../AccountsAndFinanceManagement/Tables/SuspendedTransactions";
import ManualLoanRepaymentTable from "../AccountsAndFinanceManagement/Tables/ManualLoanRepayment";
import InterestWaiverTable from "../AccountsAndFinanceManagement/Tables/InterestWaiver";
import AccountsTable from "../AccountsAndFinanceManagement/Tables/Accounts";
import FiscalYearTable from "../AccountsAndFinanceManagement/Tables/FiscalYears";
import PaymentTypesTable from "../AccountsAndFinanceManagement/Tables/PaymentTypes";
import TaxAuthorityTable from "../AccountsAndFinanceManagement/Tables/TaxAuthorities";
import TaxRateTable from "../AccountsAndFinanceManagement/Tables/TaxRates";
import CompanyTable from "../CompanyManagement/Company";
import RegionTable from "../CompanyManagement/Regions";
import BranchTable from "../CompanyManagement/Branch";
import DepartmetsTable from "../CompanyManagement/Departments";
import AddOnsTable from "../CompanyManagement/Add-Ons";
import StorageUnitsTable from "../CompanyManagement/StoreageUnits";
import SmsSettings from "../CompanyManagement/SmsSettings";
import EmailSettingsForm from "../CompanyManagement/CompanyEmailSettings/EditableForm";
import MpesaCredentialsForm from "../CompanyManagement/MpesaSettings";
import IndustryType from "../SetupManagement/IndustryTypes";
import BusinessType from "../SetupManagement/BusinessTypes";
import ProductRepaymentTypeTable from "../SetupManagement/ProductRepaymentType";
import ProductRepaymentFrequencies from "../SetupManagement/ProductRepaymentFrequency";
import CustomerRelations from "../SetupManagement/CustomerRelationships";
import GenderTable from "../SetupManagement/Gender";
import SubscriptionPlansTable from "../SetupManagement/SubscriptionPlans";
import EducationLevelTable from "../SetupManagement/EducationLevel";
import ResidencePeriodTable from "../SetupManagement/ResidencePeriod";
import Marital from "../SetupManagement/MaritalStatus";
import UploadLogoTable from "../CompanyManagement/UploadLogo";
import CustomSMSPage from "../Adohc/promotions/customSMS";
import EmailsPage from "../Adohc/promotions/emails";
import ProcessTable from "../SetupManagement/Process";
import TransactionTypeTable from "../SetupManagement/TransactionType";
import CustomSmsRegex from "../Adohc/CustomSmsRegex";
import SingularMigrationPage from "../Customers/customers/customerMigartion/SingularMigration";
import BulkMigrationPage from "../Customers/customers/customerMigartion/BulkMigration";
import CustomerBranchMigrationPage from "../Customers/customers/customerMigartion/interBranchMigration";
import SingularGroupMigrationPage from "../Customers/customers/groupcustomerMigration/singularGroupFoMigration";
import GroupBranchMigrationPage from "../Customers/customers/groupcustomerMigration/GroupInterBranchMigration";
import BulkGroupMigrationPage from "../Customers/customers/groupcustomerMigration/BuikGroupMigration";
import SubscriptionTable from "../CompanyManagement/Subscribe";
import SubscriptionPaymentEntry from "../AccountsAndFinanceManagement/Tables/SubscriptionPaymentEntry";
import ShortCodeTypesTable from "../SetupManagement/ShortCodeTypes";
import CollateralClassPage from "../SetupManagement/Collaterateral/CollateralClasses";
import CollateralConditionPage from "../SetupManagement/Collaterateral/CollateralCondition";
import CollateralLocationPage from "../SetupManagement/Collaterateral/CollateralLocation";
import CollateralSubclassPage from "../SetupManagement/Collaterateral/CollateralSubclass";
import CollateralTypePage from "../SetupManagement/Collaterateral/CollateralTypes";
import Excludedreportkeywords from "../SetupManagement/Excludedreportkeywords";
import BranchMigrate from "../Customers/BranchRegionMigration/BranchRegion";
import EmployerTable from "../SetupManagement/Employers";
import LeavePolicyTable from "../HRManagemenet/setups/leavePolicy";
import LeaveApproversTable from "../HRManagemenet/setups/Approvers";
import CalendarSetupTable from "../HRManagemenet/setups/CompanyCalendarSetups";
import ImprestApproversTable from "../HRManagemenet/setups/ImprestApprovers";
import UserFinanceDetailsForm from "../HRManagemenet/setups/FinancialDetails";
import PCApplicationsTable from "../HRManagemenet/PettyCash/PCApplications";
import PCApplicationsByUserTable from "../HRManagemenet/PettyCash/PCApplicationsByUser";
import CustomerMobileMigration from "../Customers/customers/customerMigartion/ChangeCustomerMobilenumber";
import CustomerMobileNumberApproval from "../Customers/customers/CustomerMobileNumberTransfer";
import LeaveTypesTable from "../HRManagemenet/setups/LeaveTypes";
import RecurringTypesTable from "../HRManagemenet/setups/RecurringTypes";
import DisbursementTypesTable from "../HRManagemenet/setups/DisbursementTypes";
import RelieversTable from "../HRManagemenet/setups/Relievers";
import SmsApisTable from "../SetupManagement/SmsApis";
import ApprovedLeavesTable from "../HRManagemenet/ApprovedLeaves";
import ApprovedStaffClaimsTable from "../HRManagemenet/ApprovedStaffClaim";
import ApprovedImprestTable from "../HRManagemenet/ApprovedImprest";
import DIYTable from "../CompanyManagement/DIYCompanies";
import CollateralAssetTypeTable from "../SetupManagement/AssetFinanceSetups/CollateralAssetType";
import CollateralAssetSubtypesTable from "../SetupManagement/AssetFinanceSetups/CollateralAssetSubtypes";
import AssetTypeDocumentRequirementTable from "../SetupManagement/AssetFinanceSetups/AssetTypeDocumentRequirement";
import RegistryTable from "../SetupManagement/AssetFinanceSetups/Registry";
import ValuerFirmTable from "../SetupManagement/AssetFinanceSetups/ValuerFirm";
import CarModelsTable from "../SetupManagement/AssetFinanceSetups/CarModels";
import CommissionTable from "../AccountsAndFinanceManagement/Tables/Commission";
import ApprovedCommissionTable from "../AccountsAndFinanceManagement/Tables/ApproveCommission";
import CarMakesTable from "../SetupManagement/AssetFinanceSetups/CarMakes";
import DisbursementMethodsTable from "../SetupManagement/DisbursmentMethods";
import BanksTable from "../SetupManagement/Banks";
import DeviceLockPoliciesTable from "../SetupManagement/DeviceSetups/DeviceLockPolicies";
import DeviceLockActionsTable from "../SetupManagement/DeviceSetups/DeviceLockActions";
import DeviceSetups from "../SetupManagement/DeviceSetups/DeviceSetups";
import BankBranchesTable from "../SetupManagement/BankBranches";


export const BusinessTypes = () => {
  return (
    <DynamicCard>
      <BusinessType />
    </DynamicCard>
  );
};

export const IndustryTypes = () => {
  return (
    <DynamicCard>
      <IndustryType />
    </DynamicCard>
  );
};

export const ProductRepaymentType = () => {
  return (
    <DynamicCard>
      <ProductRepaymentTypeTable />
    </DynamicCard>
  );
};

export const ProductRepaymentFrequency = () => {
  return (
    <DynamicCard>
      <ProductRepaymentFrequencies />
    </DynamicCard>
  );
};
export const CustomerRelationships = () => {
  return (
    <DynamicCard>
      <CustomerRelations />
    </DynamicCard>
  );
};

export const EducationLevel = () => {
  return (
    <DynamicCard>
      <EducationLevelTable />
    </DynamicCard>
  );
};
export const ResidencePeriod = () => {
  return (
    <DynamicCard>
      <ResidencePeriodTable />
    </DynamicCard>
  );
};
export const MaritalStatus = () => {
  return (
    <DynamicCard>
      <Marital />
    </DynamicCard>
  );
};

export const Gender = () => {
  return (
    <DynamicCard>
      <GenderTable />
    </DynamicCard>
  );
};
export const SMSAPI = () => {
  return (
    <DynamicCard>
      <SmsApisTable />
    </DynamicCard>
  );
};
export const Employer = () => {
  return (
    <DynamicCard>
      <EmployerTable />
    </DynamicCard>
  );
};

export const SubscriptionPlans = () => {
  return (
    <DynamicCard>
      <SubscriptionPlansTable />
    </DynamicCard>
  );
};

export const AccountCategory = () => {
  return (
    <DynamicCard>
      <AccountCategoriesTable />
    </DynamicCard>
  );
};
export const AccountSubcategory = () => {
  return (
    <DynamicCard>
      <AccountSubcategoriesTable />
    </DynamicCard>
  );
};
export const Accounts = () => {
  return (
    <DynamicCard>
      <AccountsTable />
    </DynamicCard>
  );
};

export const ShortCodeTypes = () => {
  return (
    <DynamicCard>
      <ShortCodeTypesTable />
    </DynamicCard>
  );
};
export const SuspendedTransactions = () => {
  return (
    <DynamicCard>
      <SuspendedTransactionsTable />
    </DynamicCard>
  );
};
export const Commission = () => {
  return (
    <DynamicCard>
      <CommissionTable />
    </DynamicCard>
  );
};
export const ApprovedCommissions = () => {
  return (
    <DynamicCard>
      <ApprovedCommissionTable />
    </DynamicCard>
  );
};
export const DisbursmentMethods = () => {
  return (
    <DynamicCard>
      <DisbursementMethodsTable />
    </DynamicCard>
  );
};
export const Banks = () => {
  return (
    <DynamicCard>
      <BanksTable />
    </DynamicCard>
  );
};
export const BankBranches = () => {
  return (
    <DynamicCard>
      <BankBranchesTable />
    </DynamicCard>
  );
};
export const ManualLoanRepayment = () => {
  return (
    <DynamicCard>
      <ManualLoanRepaymentTable />
    </DynamicCard>
  );
};
export const InterestWaiver = () => {
  return (
    <DynamicCard>
      <InterestWaiverTable />
    </DynamicCard>
  );
};
export const SubscriptionPaymentEntries = () => {
  return (
    <DynamicCard>
      <SubscriptionPaymentEntry />
    </DynamicCard>
  );
};

export const FiscalYearsView = () => {
  return (
    <DynamicCard>
      <FiscalYearTable />
    </DynamicCard>
  );
};
export const PaymentTypesView = () => {
  return (
    <DynamicCard>
      <PaymentTypesTable />
    </DynamicCard>
  );
};
export const TaxAuthoritiesView = () => {
  return (
    <DynamicCard>
      <TaxAuthorityTable />
    </DynamicCard>
  );
};
export const TaxRatesView = () => {
  return (
    <DynamicCard>
      <TaxRateTable />
    </DynamicCard>
  );
};
export const Companies = () => {
  return (
    <DynamicCard>
      <CompanyTable />
    </DynamicCard>
  );
};

export const Regions = () => {
  return (
    <DynamicCard>
      <RegionTable />
    </DynamicCard>
  );
};

export const CompanyBranches = () => {
  return (
    <DynamicCard>
      <BranchTable />
    </DynamicCard>
  );
};
export const DIYCompanies = () => {
  return (
    <DynamicCard>
      <DIYTable />
    </DynamicCard>
  );
};

export const DepartmentView = () => {
  return (
    <DynamicCard>
      <DepartmetsTable />
    </DynamicCard>
  );
};

export const AddOnView = () => {
  return (
    <DynamicCard>
      <AddOnsTable />
    </DynamicCard>
  );
};

export const StorageUnitsView = () => {
  return (
    <DynamicCard>
      <StorageUnitsTable />
    </DynamicCard>
  );
};
export const SMSSettings = () => {
  return (
    <DynamicCard>
      <SmsSettings />
    </DynamicCard>
  );
};
export const MpesaSettings = () => {
  return (
    <DynamicCard>
      <MpesaCredentialsForm />
    </DynamicCard>
  );
};
export const EmailSettings = () => {
  return (
    <DynamicCard>
      {/* // <CompanyEmailSettingsTable /> */}
      <EmailSettingsForm />
    </DynamicCard>
  );
};
export const Sms = () => {
  return (
    <DynamicCard>
      <CustomSMSPage />
    </DynamicCard>
  );
};
export const SmsPlaceholders = () => {
  return (
    <DynamicCard>
      <CustomSmsRegex />
    </DynamicCard>
  );
};
export const Emails = () => {
  return (
    <DynamicCard>
      <EmailsPage />
    </DynamicCard>
  );
};

export const AdhocSMSBulk = () => {
  return (
    <DynamicCard>
      <CustomSMSPage />
    </DynamicCard>
  );
};


export const UploadLogo = () => {
  return (
    <DynamicCard>
      <UploadLogoTable />
    </DynamicCard>
  );
};
export const Subscribe = () => {
  return (
    <DynamicCard>
      <SubscriptionTable />
    </DynamicCard>
  );
};

export const Process = () => {
  return (
    <DynamicCard>
      <ProcessTable />
    </DynamicCard>
  );
};

export const TransactionType = () => {
  return (
    <DynamicCard>
      <TransactionTypeTable />
    </DynamicCard>
  );
};

export const SingularMigration = () => {
  return (
    <DynamicCard>
      <SingularMigrationPage />
    </DynamicCard>
  );
};
export const ChangeMobileNumber = () => {
  return (
    <DynamicCard>
      <CustomerMobileMigration />
    </DynamicCard>
  );
};
export const MobileNumberTransferApproval = () => {
  return (
    <DynamicCard>
      <CustomerMobileNumberApproval />
    </DynamicCard>
  );
};

export const BulkMigration = () => {
  return (
    <DynamicCard>
      <BulkMigrationPage />
    </DynamicCard>
  );
};

export const CustomerBranchMigration = () => {
  return (
    <DynamicCard>
      <CustomerBranchMigrationPage />
    </DynamicCard>
  );
};

export const BranchToRegion = () => {
  return (
    <DynamicCard>
      <BranchMigrate />
    </DynamicCard>
  );
};

export const SingularGroupMigration = () => {
  return (
    <DynamicCard>
      <SingularGroupMigrationPage />
    </DynamicCard>
  );
};
export const BranchRegionMigration = () => {
  return (
    <DynamicCard>
      <BranchMigrate />
    </DynamicCard>
  );
};

export const BulkGroupMigration = () => {
  return (
    <DynamicCard>
      <BulkGroupMigrationPage />
    </DynamicCard>
  );
};
export const CollateralClass = () => {
  return (
    <DynamicCard>
      <CollateralClassPage />
    </DynamicCard>
  );
};
export const CollateralCondition = () => {
  return (
    <DynamicCard>
      <CollateralConditionPage />
    </DynamicCard>
  );
};
export const CollateralLocation = () => {
  return (
    <DynamicCard>
      <CollateralLocationPage />
    </DynamicCard>
  );
};
export const CollateralSubClass = () => {
  return (
    <DynamicCard>
      <CollateralSubclassPage />
    </DynamicCard>
  );
};
export const CollateralType = () => {
  return (
    <DynamicCard>
      <CollateralTypePage />
    </DynamicCard>
  );
};

export const GroupBranchMigration = () => {
  return (
    <DynamicCard>
      <GroupBranchMigrationPage />
    </DynamicCard>
  );
};
export const ReportKeyWords = () => {
  return (
    <DynamicCard>
      <Excludedreportkeywords />
    </DynamicCard>
  );
};
export const LeavePolicy = () => {
  return (
    <DynamicCard>
      <LeavePolicyTable />
    </DynamicCard>
  );
};
export const LeaveTypes = () => {
  return (
    <DynamicCard>
      <LeaveTypesTable />
    </DynamicCard>
  );
};
export const DisbursementType = () => {
  return (
    <DynamicCard>
      <DisbursementTypesTable />
    </DynamicCard>
  );
};
export const RecurringTypes = () => {
  return (
    <DynamicCard>
      <RecurringTypesTable />
    </DynamicCard>
  );
};
export const LeaveApprovers = () => {
  return (
    <DynamicCard>
      <LeaveApproversTable />
    </DynamicCard>
  );
};

export const Relievers = () => {
  return (
    <DynamicCard>
      <RelieversTable />
    </DynamicCard>
  );
};
export const CalendarSetups = () => {
  return (
    <DynamicCard>
      <CalendarSetupTable />
    </DynamicCard>
  );
};
export const ImprestApprovers = () => {
  return (
    <DynamicCard>
      <ImprestApproversTable />
    </DynamicCard>
  );
};
export const FinanceDetails = () => {
  return (
    <DynamicCard>
      <UserFinanceDetailsForm />
    </DynamicCard>
  );
};
export const AllPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsTable />
    </DynamicCard>
  );
};

export const MyPettyCashApplications = () => {
  return (
    <DynamicCard>
      <PCApplicationsByUserTable />
    </DynamicCard>
  );
};

export const CollateralAssetType = () => {
  return (
    <DynamicCard>
      <CollateralAssetTypeTable />
    </DynamicCard>
  );
};
export const CollateralAssetSubtype = () => {
  return (
    <DynamicCard>
      <CollateralAssetSubtypesTable />
    </DynamicCard>
  );
};

export const DocumentRequirement = () => {
  return (
    <DynamicCard>
      <AssetTypeDocumentRequirementTable />
    </DynamicCard>
  );
};

export const DocumentRequirements = () => {
  return (
    <DynamicCard>
      <AssetTypeDocumentRequirementTable />
    </DynamicCard>
  );
};

export const AssetTypeDocumentRequirement = () => {
  return (
    <DynamicCard>
      <AssetTypeDocumentRequirementTable />
    </DynamicCard>
  );
};

export const Registry = () => {
  return (
    <DynamicCard>
      <RegistryTable />
    </DynamicCard>
  );
};

export const ValuerFirm = () => {
  return (
    <DynamicCard>
      <ValuerFirmTable />
    </DynamicCard>
  );
};

export const CarModels = () => {
  return (
    <DynamicCard>
      <CarModelsTable />
    </DynamicCard>
  );
};

export const CarModel = () => {
  return (
    <DynamicCard>
      <CarModelsTable />
    </DynamicCard>
  );
};

export const CarMakes = () => {
  return (
    <DynamicCard>
      <CarMakesTable />
    </DynamicCard>
  );
};

export const CarMake = () => {
  return (
    <DynamicCard>
      <CarMakesTable />
    </DynamicCard>
  );
};

export const DeviceLockPolicies = () => {
  return (
    <DynamicCard>
      <DeviceLockPoliciesTable />
    </DynamicCard>
  );
};

export const DeviceLockPolicy = () => {
  return (
    <DynamicCard>
      <DeviceLockPoliciesTable />
    </DynamicCard>
  );
};

export const DevicePolicies = () => {
  return (
    <DynamicCard>
      <DeviceLockPoliciesTable />
    </DynamicCard>
  );
};

export const DevicePolicy = () => {
  return (
    <DynamicCard>
      <DeviceLockPoliciesTable />
    </DynamicCard>
  );
};

export const DeviceLockActions = () => {
  return (
    <DynamicCard>
      <DeviceLockActionsTable />
    </DynamicCard>
  );
};

export const DeviceActions = () => {
  return (
    <DynamicCard>
      <DeviceLockActionsTable />
    </DynamicCard>
  );
};

export const DeviceSetupsTab = () => {
  return (
    <DynamicCard>
      <DeviceSetups />
    </DynamicCard>
  );
};


